import React from "react";
import { AlertTriangle, BadgeInfo, Users } from "lucide-react";
import { Sekcja, RowIcon, mono } from "./atoms";

export default function KnfListSection({ items = [] }) {
  return (
    <Sekcja
      title="Lista ostrzeżeń KNF"
      icon={AlertTriangle}
      titleStyle={{ fontSize: 20, color: "#0b74e5", textDecorationThickness: "2px", textUnderlineOffset: 4 }}
    >
      {Array.isArray(items) && items.length > 0 ? (
        <div style={{ display: "grid", gap: 12 }}>
          {items.map((it, i) => (
            <div key={i}>
              {/* Nagłówek wpisu (bez tła/borderów) */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 8,
                  marginBottom: 4,
                }}
              >
                <div style={{ display: "inline-flex", alignItems: "center", gap: 8, fontWeight: 700 }}>
                  <AlertTriangle size={16} />
                  <span>{it.company_name || "—"}</span>
                </div>
                <div style={{ fontSize: 12, color: "#6b7280" }}>
                  Ostatnia weryfikacja: <strong>{it.last_checked || "—"}</strong>
                </div>
              </div>

              {/* FIX: render a single node (no array) */}
              <RowIcon icon={BadgeInfo} label="Identyfikacja">
                {it.identification_type || it.identification_number ? (
                  <span>
                    {it.identification_type}
                    {it.identification_type && it.identification_number ? ": " : ""}
                    {it.identification_number ? mono(it.identification_number) : null}
                  </span>
                ) : (
                  <em>—</em>
                )}
              </RowIcon>

              <RowIcon icon={Users} label="Prokuratura">
                {it.prosecutor || <em>—</em>}
              </RowIcon>
            </div>
          ))}
        </div>
      ) : (
        <em>Brak wpisów na liście ostrzeżeń KNF.</em>
      )}
    </Sekcja>
  );
}
